window.LR_ALPHA={"label": "Buchstaben", "start": 4, "vorlagen": {"2": {"name": "layer-902020", "buchst": ["layer-902001", "layer-902002"]}, "3": {"name": "layer-903020", "buchst": ["layer-903001", "layer-903002", "layer-903003"]}, "4": {"name": "layer-904020", "buchst": ["layer-904001", "layer-904002", "layer-904003", "layer-904004"]}, "5": {"name": "layer-905020", "buchst": ["layer-905001", "layer-905002", "layer-905003", "layer-905004", "layer-905005"]}, "6": {"name": "layer-906020", "buchst": ["layer-906001", "layer-906002", "layer-906003", "layer-906004", "layer-906005", "layer-906006"]}, "7": {"name": "layer-907020", "buchst": ["layer-907001", "layer-907002", "layer-907003", "layer-907004", "layer-907005", "layer-907006", "layer-907007"]}, "8": {"name": "layer-908020", "buchst": ["layer-908001", "layer-908002", "layer-908003", "layer-908004", "layer-908005", "layer-908006", "layer-908007", "layer-908008"]}, "9": {"name": "layer-909020", "buchst": ["layer-909001", "layer-909002", "layer-909003", "layer-909004", "layer-909005", "layer-909006", "layer-909007", "layer-909008", "layer-909009"]}, "10": {"name": "layer-910020", "buchst": ["layer-910001", "layer-910002", "layer-910003", "layer-910004", "layer-910005", "layer-910006", "layer-910007", "layer-910008", "layer-910009", "layer-910010"]}}};
/* Lorelia Automatik fuer teeinblue-Formulare (28.09.2026)
 * 1) Tage-Rechner: zwei Datumsfelder -> Tageszahl (nur zwischen zwei FESTEN Daten, Lucas Regel).
 * 2) Tier-Alphabet: aus dem Vornamen die passende Vorlage (2-10 Buchstaben) waehlen und jede
 *    Buchstaben-Kachel (dynamic-by-text) fuellen.
 * teeinblue ist Vue: nur Eingabewerte setzen + 'input'/'change' ausloesen, keine DOM-Umbauten.
 * Felder werden ueber name="layer-<id>" gefunden (Ebenen-ID aus dem Artwork).
 */
(function () {
  'use strict';
  var TAGE = [{ a: 'layer-587106', b: 'layer-587108', ziel: 'layer-587103' }];
  var ALPHA = window.LR_ALPHA || null;   // {vorlagen:{2:{name:'layer-…', buchst:['layer-…',…]}, …}, label:'Buchstaben'}

  function feld(name) { return document.querySelector('.tee-form-wrapper [name="' + name + '"]'); }
  function setzen(el, wert) {
    if (!el || el.value === wert) return;
    var proto = el.tagName === 'TEXTAREA' ? HTMLTextAreaElement.prototype : HTMLInputElement.prototype;
    Object.getOwnPropertyDescriptor(proto, 'value').set.call(el, wert);
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function datum(s) {
    var m = String(s || '').trim().match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
    if (!m) return null;
    var d = new Date(Date.UTC(+m[3], +m[2] - 1, +m[1]));
    return d.getUTCDate() === +m[1] && d.getUTCMonth() === +m[2] - 1 ? d : null;
  }
  function tausender(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function tageRechnen() {
    TAGE.forEach(function (t) {
      var a = feld(t.a), b = feld(t.b), z = feld(t.ziel);
      if (!a || !b || !z) return;
      if (!z.readOnly) { z.readOnly = true; z.title = 'Wird automatisch aus den beiden Daten berechnet'; }
      var da = datum(a.value), db = datum(b.value);
      if (da && db) setzen(z, tausender(Math.round(Math.abs(db - da) / 864e5)));
    });
  }

  // ---- Tier-Alphabet ----
  var alphaName = '';
  function vorname(s) {
    var v = String(s || '').trim().split(/[\s-]+/)[0] || '';
    return v.toUpperCase().replace(/SS/g, 'ß').replace(/[^A-ZÄÖÜ]/g, '');
  }
  function vorlageWaehlen(n) {
    var w = document.querySelector('.tee-form-wrapper'); if (!w) return false;
    var ziel = n + ' ' + ALPHA.label;
    var sel = [].slice.call(w.querySelectorAll('select')).filter(function (s) {
      return [].some.call(s.options, function (o) { return o.text.trim() === ziel; });
    })[0];
    if (sel) {
      var opt = [].filter.call(sel.options, function (o) { return o.text.trim() === ziel; })[0];
      if (sel.value !== opt.value) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); return true; }
      return false;
    }
    var lab = [].slice.call(w.querySelectorAll('label')).filter(function (l) { return l.textContent.trim() === ziel; })[0];
    var inp = lab && (lab.querySelector('input') || document.getElementById(lab.htmlFor));
    if (lab && !(inp && inp.checked)) { lab.click(); return true; }
    return false;
  }
  // Tier-Kachel = Clipart-Radio (Clipart-Name = Buchstabe); Auswahl nur ueber label.click() (Vue)
  function tierWaehlen(id, ch) {
    if (!ch) return;
    var w = document.querySelector('.tee-form-wrapper .tee-field--' + id); if (!w) return;
    var lab = w.querySelector('label[data-title="' + ch + '"]'); if (!lab) return;
    var inp = document.getElementById(lab.htmlFor);
    if (inp && !inp.checked) lab.click();
  }
  function alphabet() {
    if (!ALPHA) return;
    var aktiv = null;
    Object.keys(ALPHA.vorlagen).forEach(function (n) { var f = feld(ALPHA.vorlagen[n].name); if (f) aktiv = { n: +n, f: f, v: ALPHA.vorlagen[n] }; });
    if (!aktiv) { if (!alphaName) vorlageWaehlen(ALPHA.start || 4); return; }   // ohne Vorlage baut teeinblue keine Felder
    if (aktiv.f.value && aktiv.f.value !== alphaName) alphaName = aktiv.f.value;
    var vn = vorname(alphaName).replace(/ß/g, 'SS');
    if (vn.length < 2) return;
    var n = Math.min(10, vn.length);
    if (n !== aktiv.n) {
      if (document.activeElement === aktiv.f) return;                  // nie mitten im Tippen umbauen
      if (vorlageWaehlen(n)) return;                                   // nach dem Wechsel laeuft alphabet() erneut
    }
    setzen(aktiv.f, alphaName);
    // Buchstabe n ist ein Textfeld (Quelle der dynamic-by-text-Kachel); Bildauswahl nur als Rueckfall
    aktiv.v.buchst.forEach(function (id, i) { var f = feld(id); if (f && f.type === 'text') setzen(f, vn[i] || ''); else tierWaehlen(id, vn[i]); });
    // teeinblue schreibt nach der eigenen Verarbeitung der Namenseingabe teils den alten Stand zurueck
    var falsch = aktiv.v.buchst.some(function (id, i) { var f = feld(id); if (f && f.type === 'text') return f.value !== (vn[i] || ''); var w = document.querySelector('.tee-form-wrapper .tee-field--' + id), l = w && vn[i] && w.querySelector('label[data-title="' + vn[i] + '"]'), e = l && document.getElementById(l.htmlFor); return !!(e && !e.checked); });
    if (falsch && nachpruef < 10) { nachpruef++; setTimeout(planen, 400); } else if (!falsch) nachpruef = 0;
  }
  var nachpruef = 0;

  var geplant = false;
  function lauf() { geplant = false; try { tageRechnen(); alphabet(); } catch (e) { console.warn('lr-auto', e); } }
  function planen() { if (!geplant) { geplant = true; setTimeout(lauf, 120); } }
  document.addEventListener('input', function (e) { if (e.isTrusted && e.target.closest && e.target.closest('.tee-form-wrapper')) planen(); }, true);
  document.addEventListener('change', function (e) { if (e.isTrusted) planen(); }, true);
  document.addEventListener('focusout', function (e) { if (e.target.closest && e.target.closest('.tee-form-wrapper')) planen(); }, true);
  new MutationObserver(planen).observe(document.documentElement, { childList: true, subtree: true });
})();
